import { getClientHost } from './constants';

export const PUBLIC_URL = '/';
export const HOME_PAGE_ROUTE = '/dashboard';
export const ADMIN_PAGE_ROUTE = '/admin';
export const SETTINGS_PAGE_ROUTE = '/settings';
export const LOGIN_PAGE_ROUTE = '/login';
export const LOGOUT_PAGE_ROUTE = '/logout';

export const pageAccess = (userRole, partner) => {
  let page_access = [];
  switch (userRole) {
    case 'billing_admin':
      page_access = [
        { name: 'Home', path: 'dashboard' },
        { name: 'Patient Data', path: 'patients' },
        { name: 'Resources', path: 'resources', disabled: true },
        { name: 'Messaging', path: 'messages', disabled: true },
        { name: 'Settings', path: 'settings', disabled: true },
        { name: 'Help', path: 'help', disabled: true },
        { name: 'Billing', path: 'billing', url: getClientHost(partner) + '/billing', api: 'v1' },
      ];
      break;
    case 'developer':
    case 'internal_staff':
    case 'admin':
    case 'partner_admin':
    case 'editor':
    default:
      page_access = [
        { name: 'Home', path: 'dashboard' },
        { name: 'Patient Data', path: 'patients' },
        { name: 'Diet Quality', path: 'quality' },
        { name: 'Resources', path: 'resources', url: 'https://www.dietid.com/clientresources' },
        // { name: 'Messaging', path: 'messages', disabled: true },
        // { name: 'Settings', path: 'settings', disabled: true },
        // { name: 'Help', path: 'help', disabled: true },
      ];
      break;
  }
  return page_access;
};
